import { Button, Icon, Menu, MenuButton, MenuList, MenuItem } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { HiChevronDown, HiOutlineBolt, HiOutlineClipboardDocumentList } from "react-icons/hi2";
import { c, PALETTES } from "./classroomColors";

const CreateCustomButton = ({ subjectGuid, courseGuid, classroomName, isDark = true }) => {
  const navigate = useNavigate();
  const p = isDark ? PALETTES.dark : PALETTES.light;

  // The builder is its own page, so the classroom stays in the history stack.
  const openWith = (paperType) => {
    navigate("/classroom/teacher/create-paper", {
      state: {
        subjectGuid,
        courseGuid,
        classroomName,
        userType: "INSTRUCTOR",
        paperType,
      },
    });
  };

  return (
    <>
      <Menu autoSelect={false}>
        <MenuButton
          as={Button}
          rightIcon={<Icon as={HiChevronDown} boxSize="15px" />}
          display="inline-flex"
          alignItems="center"
          gap="8px"
          padding="8px 14px"
          borderRadius="8px"
          border="1px solid"
          borderColor={c.border}
          background={c.surface}
          color={c.text}
          fontSize="14px"
          fontWeight="500"
          _hover={{ background: c.hover }}
          _active={{ background: c.hover }}
        >
          Create
        </MenuButton>
        <MenuList
          className="stande-classroom"
          data-theme={isDark ? "dark" : "light"}
          minWidth="180px"
          bg={p.surface}
          border="1px solid"
          borderColor={p.border}
          borderRadius="12px"
          padding="6px"
          boxShadow="0 16px 40px -16px rgba(0,0,0,0.5)"
        >
          <MenuItem
            icon={<Icon as={HiOutlineBolt} boxSize="18px" color={p.textSub} />}
            onClick={() => openWith("QUIZ")}
            bg="transparent"
            color={p.text}
            borderRadius="8px"
            fontSize="14px"
            _hover={{ bg: p.hover }}
            _focus={{ bg: p.hover }}
          >
            Quiz
          </MenuItem>
          <MenuItem
            icon={<Icon as={HiOutlineClipboardDocumentList} boxSize="18px" color={p.textSub} />}
            onClick={() => openWith("ASSIGNMENT")}
            bg="transparent"
            color={p.text}
            borderRadius="8px"
            fontSize="14px"
            _hover={{ bg: p.hover }}
            _focus={{ bg: p.hover }}
          >
            Assignment
          </MenuItem>
        </MenuList>
      </Menu>
    </>
  );
};

export default CreateCustomButton;
